class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, null, null, this.dataset.giftWrapKey);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

// Hediye Paketi ürününün varyant ID'si
const GIFT_WRAP_VARIANT_ID = 45838382759970;

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', (event) => {
      if (event.target.matches('.js-gift-wrap-checkbox')) {
        // Hediye paketi checkbox'ı: ayrı akış, debounce'a girmez (anlık tepki ister)
        this.onGiftWrapChange(event);
        return;
      }
      debouncedOnChange(event);
    });
  }

  cartUpdateUnsubscriber = undefined;
  _cartItemsCache = null;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.refreshCartItemsCache();
  }

  // Hediye paketi satırlarını line numarasından bağımsız bulabilmek için
  // /cart.js'ten güncel item listesini çekip belleğe alır.
  refreshCartItemsCache() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        this._cartItemsCache = cart.items;
      })
      .catch((e) => console.error(e));
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId,
      event.target.dataset.giftWrapKey
    );
  }

  // Hediye Paketi checkbox'ı işaretlendiğinde/kaldırıldığında çalışır.
  // checked  -> ana ürünün adediyle eşit miktarda hediye paketi sepete eklenir (cart/add.js)
  // unchecked -> o ana ürüne bağlı hediye paketi satırı sepetten kaldırılır (cart/change.js, quantity:0)
  onGiftWrapChange(event) {
    const checkbox = event.target;
    const giftWrapKey = checkbox.dataset.giftWrapKey; // ana satırı tanımlayan benzersiz anahtar
    const mainLine = checkbox.dataset.index; // ana ürünün cart.items içindeki 1-tabanlı satır no'su
    const mainLineItem =
      document.getElementById(`CartItem-${mainLine}`) || document.getElementById(`CartDrawer-Item-${mainLine}`);
    const mainQuantityInput = mainLineItem
      ? mainLineItem.querySelector('input.quantity__input, input[data-quantity-variant-id]')
      : null;
    const mainQuantity = mainQuantityInput ? parseInt(mainQuantityInput.value, 10) || 1 : 1;

    checkbox.disabled = true;
    this.enableLoading(mainLine);

    if (checkbox.checked) {
      this.addGiftWrap(giftWrapKey, mainQuantity, mainLine, checkbox);
    } else {
      this.removeGiftWrap(giftWrapKey, mainLine, checkbox);
    }
  }

  addGiftWrap(giftWrapKey, quantity, mainLine, checkbox) {
    const body = JSON.stringify({
      items: [
        {
          id: GIFT_WRAP_VARIANT_ID,
          quantity: quantity,
          properties: {
            _gift_wrap_for: giftWrapKey,
          },
        },
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          checkbox.checked = false;
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = parsedState.description || window.cartStrings.error;
          return;
        }
        this.renderSectionsAfterGiftWrapChange(parsedState, mainLine);
      })
      .catch(() => {
        checkbox.checked = false;
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(mainLine);
      });
  }

  removeGiftWrap(giftWrapKey, mainLine, checkbox) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        this._cartItemsCache = cart.items;
        const giftWrapLine = this.findGiftWrapLine(giftWrapKey);
        if (!giftWrapLine) {
          // Bulunamadıysa zaten sepette yok; checkbox'ı işaretsiz bırak.
          this.disableLoading(mainLine);
          return;
        }

        const body = JSON.stringify({
          line: giftWrapLine,
          quantity: 0,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            this.renderSectionsAfterGiftWrapChange(parsedState, mainLine);
          })
          .finally(() => {
            this.disableLoading(mainLine);
          });
      })
      .catch(() => {
        checkbox.checked = true;
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
        this.disableLoading(mainLine);
      });
  }

  // Verilen gift_wrap_for anahtarına sahip line item'ın 1-tabanlı satır numarasını cart state'inden bulur.
  findGiftWrapLine(giftWrapKey) {
    if (!this._cartItemsCache) return null;
    const index = this._cartItemsCache.findIndex(
      (item) => item.properties && item.properties._gift_wrap_for === giftWrapKey
    );
    return index === -1 ? null : index + 1;
  }

  // Ana ürünün adedi +/- ile değiştiğinde, ona bağlı hediye paketi satırının adedini de eşitler.
  // updateQuantity() başarılı tamamlandıktan sonra çağrılır.
  // Not: cache'e güvenmek yerine /cart.js'ten TAZE veri çekiyoruz; updateQuantity()'nin kendi
  // fetch'i sırasında cache bayatlamış olabilir (örn. art arda hızlı +/- tıklamaları).
  syncGiftWrapQuantity(giftWrapKey, newQuantity) {
    if (!giftWrapKey) return Promise.resolve();

    return fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        this._cartItemsCache = cart.items;
        const giftWrapLine = this.findGiftWrapLine(giftWrapKey);
        if (!giftWrapLine) return; // bu satıra ait işaretli bir hediye paketi yok

        const giftWrapItem = cart.items[giftWrapLine - 1];
        // Zaten doğru adette ise gereksiz bir istek daha atmayalım.
        if (giftWrapItem && giftWrapItem.quantity === newQuantity) return;

        const body = JSON.stringify({
          line: giftWrapLine,
          quantity: newQuantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.errors) {
              console.error(parsedState.errors);
              return;
            }
            this._cartItemsCache = parsedState.items;

            // ÖNEMLİ: main-cart-items'ı (satır listesi) da güncelliyoruz. Aksi halde checkbox'ın
            // göründüğü HTML, hediye paketi miktarı senkronlanmadan ÖNCEKİ ara state'te kalır ve
            // checkbox kullanıcıya boş/yanlış görünür — bu da tekrar tıklayınca çift satır
            // oluşmasına (ikinci bir cart/add.js çağrısına) yol açar.
            // ÖNEMLİ: parsedState.sections içindeki key'ler qualified section ID'leridir
            // ('main-cart-footer' gibi sabit string değil), bu yüzden getSectionsToRender()'dan
            // gelen gerçek section ID'leriyle eşleştirmemiz gerekir.
            this.getSectionsToRender().forEach((section) => {
              const sectionEl = document.getElementById(section.id);
              if (!sectionEl || !parsedState.sections[section.section]) return;
              const elementToReplace = sectionEl.querySelector(section.selector) || sectionEl;
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
          });
      })
      .catch((e) => console.error(e));
  }

  renderSectionsAfterGiftWrapChange(parsedState, mainLine) {
    this._cartItemsCache = parsedState.items;

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const sectionEl = document.getElementById(section.id);
      if (!sectionEl) return;
      const elementToReplace = sectionEl.querySelector(section.selector) || sectionEl;
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  // main-cart-items / main-cart-footer elementleri sadece /cart sayfasında bulunur.
  // Drawer başka bir sayfada (örn. ana sayfa) açıkken bu elementler DOM'da olmayabilir;
  // bu yüzden var olmayan section'ları listeye hiç eklemiyoruz (aksi halde
  // document.getElementById(...).dataset.id çağrısı patlar).
  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];

    const mainCartItemsEl = document.getElementById('main-cart-items');
    if (mainCartItemsEl) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItemsEl.dataset.id,
        selector: '.js-contents',
      });
    }

    const mainCartFooterEl = document.getElementById('main-cart-footer');
    if (mainCartFooterEl) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooterEl.dataset.id,
        selector: '.js-contents',
      });
    }

    return sections;
  }

  updateQuantity(line, quantity, name, variantId, giftWrapKey) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this._cartItemsCache = parsedState.items;

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        // Ana ürünün adedi değiştiyse, ona bağlı hediye paketi satırını da senkronla.
        // quantity 0 ise ürün tamamen kaldırılmış demektir; hediye paketini de kaldır.
        if (giftWrapKey) {
          const numericQuantity = parseInt(quantity, 10);
          if (numericQuantity > 0) {
            this.syncGiftWrapQuantity(giftWrapKey, numericQuantity);
          } else {
            this.syncGiftWrapQuantity(giftWrapKey, 0);
          }
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}